/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Finish_Thank_You_Line1Inputs */

const en_register_onboarding_finish_thank_you_line1 = /** @type {(inputs: Register_Onboarding_Finish_Thank_You_Line1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you for submitting your application.`)
};

const de_register_onboarding_finish_thank_you_line1 = /** @type {(inputs: Register_Onboarding_Finish_Thank_You_Line1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vielen Dank für das Einreichen deiner Bewerbung.`)
};

/**
* | output |
* | --- |
* | "Thank you for submitting your application." |
*
* @param {Register_Onboarding_Finish_Thank_You_Line1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_finish_thank_you_line1 = /** @type {((inputs?: Register_Onboarding_Finish_Thank_You_Line1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Finish_Thank_You_Line1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_finish_thank_you_line1(inputs)
	return en_register_onboarding_finish_thank_you_line1(inputs)
});